angular.module('qkr.payment.gateway')
    .controller('paymentGatewayModalController', paymentGatewayModalController);

function paymentGatewayModalController($scope, $rootScope, $uibModalInstance, newPaymentSetting, paymentSetting,
                                       existingDefault, paymentgatewayService, departmentService, $routeSegment,
                                       FormHelper, merchantService, utils, gettextCatalog, appConfig, messageService,
                                       APP_CONSTANT, $filter, paymentSystems, bankAccountTypes) {

    $scope.newPaymentSetting = newPaymentSetting;
    $scope.$routeSegment = $routeSegment; // Used to know what we've
    $scope.form = {};
    $scope.form.currency = $rootScope.merchantInfo.defaultCurrency;
    $scope.departments = [];
    $scope.assignmentChanges = [];
    $scope.outletLevel = appConfig.outletLevel;
    $scope.isSchoolLike = merchantService.behaviour(merchantService.merchantInfo, 'schoolLike');

    $scope.readOnly = !paymentgatewayService.isPaymentSettingsUpdateAllowed();
// $scope.readOnly = false

    const placeholder = '*********',
    placeholderRegexp = new RegExp('^[*]+$'),
    formHelper = new FormHelper($scope),
    filterPlaceholders = function(hash, fields) {
            const filtered = {};
            for (const k in hash) {
                const v = hash[k];

                if (fields.indexOf(k) <= -1) {
                    filtered[k] = v;
                } else if (!placeholderRegexp.test(v))
                        filtered[k] = v;
            }

            return filtered;
        },
      init = function(paymentSetting) {
            // Selected
            $scope.paymentSystems = paymentSystems;
            $scope.bankAccountTypes = bankAccountTypes;
            $scope.paymentSystem = {};
            $scope.paymentSystem.payment = $scope.paymentSystems[paymentgatewayService.mapPaymentSystem(paymentSetting.bean, $scope.paymentSystems)];

            if ($scope.outletLevel) {
                departmentService.loadDepartments().then((promise) => {
                    $scope.departments = paymentgatewayService.getDepartments(paymentSetting, promise);
                });
                if ((paymentSetting.id && !paymentSetting.outlet) && !$scope.isSchoolLike){ // paymentSetting.id check needed to not break create
                    $scope.readOnly = true; // cannot edit merchant paymentSetting at outlet level
                }
            }

            prepareForm(paymentSetting, newPaymentSetting);
            $scope.paymentLoaded = true;
        },
       prepareForm = function(paymentSetting, newForm) {
            // COMMON
            $scope.form.alias = paymentSetting.alias;
            /*
             * If(!utils.hasNoValue(paymentSetting.currency)) { $scope.form.currency =
             * paymentSetting.currency; };
             */// MIGS
            $scope.migsExists = paymentSetting.vpcMerchant;
            $scope.form.purchaseMode = paymentSetting.purchaseMode;
            $scope.form.migsVPCMerchant = paymentSetting.vpcMerchant;
            $scope.form.migsAccessCode = paymentSetting.accessCode;
            $scope.form.migsKey = paymentSetting.key;
            $scope.form.migsRefundUserId = paymentSetting.refundUserId;
            $scope.form.migsRefundPwdKey = newForm ? '' : placeholder;

            // MPGS
            $scope.form.mpgsUsername = paymentSetting.username;
            $scope.form.mpgsPassword = newForm ? '' : placeholder; // PaymentSetting.password;
            $scope.form.mpgsPayMode = paymentSetting.payMode ? paymentSetting.payMode.name : '';

            // SIMPLIFY
            $scope.form.simplifyPublicKey = newForm ? '' : placeholder;
            $scope.form.simplifyPrivateKey = newForm ? '' : placeholder;

           // vcut-off time
            $scope.timezones = $rootScope.merchantInfo.contactDetails.country.timezones;
            $scope.form.bankName = paymentSetting.bankName;
            $scope.showBankAccountType = merchantService.behaviour(merchantService.merchantInfo, 'paymentSetting.showBankAccountType');
            $scope.form.bankAccountType = newForm ? paymentgatewayService.getDefaultBankAccountTypeKey()
                                                : paymentSetting.bankAccountType;
            $scope.isFinance1 = merchantService.behaviour(merchantService.merchantInfo, 'deptEditPage.isFinance1');
            $scope.form.cbaMerchantNumber = newForm ? '' : parseInt(paymentSetting.cbaMerchantNumber);
            if (paymentSetting.bankCutoffTimeZone) {
                $scope.form.timezoneId = paymentSetting.bankCutoffTimeZone.id;
            } else {
                if (newForm || !paymentSetting.bankCutoffTimeZone) {
                    if ($rootScope.merchantInfo.contactDetails.country.isoCode === APP_CONSTANT.AUSTRALIA_ISO_CODE) {
                        const timezone = $filter('filter')($scope.timezones, {name: APP_CONSTANT.DEFAULT_AUSTRALIA_BANK_CUTOFF_TIMEZONE_NAME});
                        $scope.form.timezoneId = timezone[0].id;
                    } else {
                        $scope.form.timezoneId = $rootScope.merchantInfo.supportedTimeZone.id;
                    }
                } else {
                    $scope.form.timezoneId = $rootScope.merchantInfo.supportedTimeZone.id;
                }
            }
            if (paymentSetting.bankCutoffInMinutes) {
                const cutoff = paymentSetting.bankCutoffInMinutes;
                let cutoffhrs = cutoff % 1440;
                const rolloveroffset = cutoffhrs < 0 ? 24 * 60 : 0;
                cutoffhrs = rolloveroffset + cutoffhrs;
                const time_cutoff = cutoffhrs;
                const time_cutoff_hours = Math.floor(time_cutoff / 60);
                const time_cutoff_minutes = time_cutoff % 60;

                const d = new Date();
                d.setHours(time_cutoff_hours);
                d.setMinutes(time_cutoff_minutes);
                $scope.form.bankCutoffInMinutes = d;
            } else {
                const d = new Date();
                if ((newForm || !paymentSetting.bankCutoffInMinutes) && $rootScope.merchantInfo.contactDetails.country.isoCode === APP_CONSTANT.AUSTRALIA_ISO_CODE) {
                    d.setHours(APP_CONSTANT.DEFAULT_AUSTRALIA_BANK_CUTOFF_HOURS);
                    d.setMinutes(APP_CONSTANT.DEFAULT_AUSTRALIA_BANK_CUTOFF_MINUTES);
                } else {
                    d.setHours(APP_CONSTANT.DEFAULT_BANK_CUTOFF_TIME);
                    d.setMinutes(APP_CONSTANT.DEFAULT_BANK_CUTOFF_TIME);
                }
                $scope.form.bankCutoffInMinutes = d;
            }
        },

        validate = function(providerType) {
            $scope.errors = null;
            const errors = {};
            const form = $scope.form;

            if (!$scope.form.alias) {
                errors.alias = gettextCatalog.getString('Alias must be entered');
            }

            switch (providerType.toUpperCase()) {
                case ('MIGS') :
                    validateFormMigs(errors);
                    break;
                case ('MPGS') :
                    validateFormMpgs(errors);
                    break;
                case ('SIMPLIFYCOMMERCE') :
                    // $scope.errors.simplifySubmit = "Simplify has not be enabled
                    // Yet";

                    validateFormSimplify(errors);
                    break;
                case ('DUMMY') :
                    // No additional validation required
                    break;
                default :
                // MessageService.error("Invalid payment system selected. Please
                // Reload the page and try again.");
            }

            if (utils.isEmpty(errors)) {
                return true;
            } else {
                $scope.errors = errors;
                return false;
            }
        },

        savePaymentProvider = function(providerType) {
            let filteredKeys = [];
            $scope.saving = true;
            if ($scope.form.bankCutoffInMinutes && !utils.isEmpty($scope.form.bankCutoffInMinutes) &&
                $scope.form.timezoneId) {
                    const cutOffHour = $scope.form.bankCutoffInMinutes.getHours();
                    const cutOffMinute = $scope.form.bankCutoffInMinutes.getMinutes();
                    const minsInDay = parseInt(cutOffHour) * 60 + parseInt(cutOffMinute);
                    $scope.form.bankCutoffInMinutes = minsInDay;
                    const timezone = $filter("filter")($scope.timezones, {id: $scope.form.timezoneId});
                    if (timezone) {
                        $scope.form.bankCutoffTimeZone = timezone[0];
                    } else {
                        $scope.form.bankCutoffTimeZone = {id: $scope.form.timezoneId};
                    }
            }
            switch (providerType.toUpperCase()) {
                case ('MIGS') :
                    filteredKeys = ['migsRefundPwdKey'];
                    if (newPaymentSetting) {
                        paymentgatewayService.createPaymentSettingsMigs(
                            filterPlaceholders($scope.form, filteredKeys), $scope.assignmentChanges)
                            .then(savePaymentsCallback, savePaymentsCallback);
                    } else {
                        paymentgatewayService.updatePaymentSettingsMigs(
                            paymentSetting.id, filterPlaceholders($scope.form, filteredKeys), $scope.assignmentChanges
                        ).then(savePaymentsCallback, savePaymentsCallback);
                    }

                    break;
                case ('MPGS') :
                    filteredKeys = ['mpgsPassword'];
                    if (newPaymentSetting) {
                        paymentgatewayService.createPaymentSettingsMpgs(
                            filterPlaceholders($scope.form, filteredKeys), $scope.assignmentChanges)
                            .then(savePaymentsCallback, savePaymentsCallback);
                    } else {
                        paymentgatewayService.updatePaymentSettingsMpgs(
                            paymentSetting.id, filterPlaceholders($scope.form, filteredKeys), $scope.assignmentChanges
                        ).then(savePaymentsCallback, savePaymentsCallback);
                    }

                    break;
                case ('SIMPLIFYCOMMERCE') :
                    filteredKeys = ['simplifyPrivateKey', 'simplifyPublicKey'];

                    if (newPaymentSetting) {
                        paymentgatewayService.createPaymentSettingsSimplify(
                            filterPlaceholders($scope.form, filteredKeys), $scope.assignmentChanges
                        ).then(savePaymentsCallback, savePaymentsCallback);
                    } else {
                        paymentgatewayService.updatePaymentSettingsSimplify(
                            paymentSetting.id, filterPlaceholders($scope.form, filteredKeys), $scope.assignmentChanges
                        ).then(savePaymentsCallback, savePaymentsCallback);
                    }
                    break;
                case ('DUMMY') :
                    if (newPaymentSetting)
                        paymentgatewayService.createPaymentSettingsDummy(
                            $scope.form, $scope.assignmentChanges)
                            .then(savePaymentsCallback, savePaymentsCallback);
                    else
                        paymentgatewayService.updatePaymentSettingsDummy(
                            paymentSetting.id, $scope.form, $scope.assignmentChanges)
                            .then(savePaymentsCallback, savePaymentsCallback);

                    break;
            }
        },

        validateMerchantNumber = function(newPaymentSetting, cbaMerchantNumber, errors) {
            if (newPaymentSetting && $scope.isFinance1) {
                if (cbaMerchantNumber === '') {
                    errors.cbaMerchantNumber = gettextCatalog.getString('Merchant Number must be entered');
                } else if (cbaMerchantNumber.toString().length !== 16) {
                    errors.cbaMerchantNumber = gettextCatalog.getString('Merchant Number field must be 16 digit number');
                }
            }
        },

        validateFormMigs = function(errors) {
            // Check for mandatory fields
            if (utils.hasNoValue($scope.form.migsVPCMerchant)) {
                errors.migsVPCMerchant = gettextCatalog.getString('MiGS Merchant Id must be entered');
            }
            if (utils.hasNoValue($scope.form.migsAccessCode)) {
                errors.migsAccessCode = gettextCatalog.getString('MiGS Access Code must be entered');
            }
            if (utils.hasNoValue($scope.form.migsKey)) {
                errors.migsKey = gettextCatalog.getString('MiGS Secure Hash must be entered');
            }
            if (utils.hasNoValue($scope.form.migsRefundUserId)) {
                errors.migsRefundUserId = gettextCatalog.getString('MiGS Refund Operator ID must be entered');
            }
            if (utils.hasNoValue($scope.form.migsRefundPwdKey) || (newPaymentSetting && placeholderRegexp.test($scope.form.migsRefundPwdKey))) {
                errors.migsRefundPwdKey = gettextCatalog.getString('MiGS Refund User Password must be entered');
            }
            if (utils.hasNoValue($scope.form.currency)) {
                errors.currency = gettextCatalog.getString('A currency must be chosen');
            }
            validateMerchantNumber(newPaymentSetting, $scope.form.cbaMerchantNumber, errors);

            return errors;
        },

        validateFormMpgs = function(errors) {
            if (utils.hasNoValue($scope.form.mpgsUsername) || (newPaymentSetting && placeholderRegexp.test($scope.form.mpgsUsername))) {
                errors.mpgsUsername = gettextCatalog.getString('MPGS Username must be entered');
            }

            if (utils.hasNoValue($scope.form.mpgsPassword) || (newPaymentSetting && placeholderRegexp.test($scope.form.mpgsPassword))) {
                errors.mpgsPassword = gettextCatalog.getString('MPGS Password must be entered');
            }

            if (utils.hasNoValue($scope.form.mpgsPayMode)) {
                errors.mpgsPayMode = gettextCatalog.getString('MPGS PayMode must be selected');
            }
            validateMerchantNumber(newPaymentSetting, $scope.form.cbaMerchantNumber, errors);
        },

        validateFormSimplify = function(errors) {
            // Check for mandatory fields
            if (utils.hasNoValue($scope.form.simplifyPublicKey) || (newPaymentSetting && placeholderRegexp.test($scope.form.simplifyPublicKey))) {
                errors.simplifyPublicKey = gettextCatalog.getString('A public key must be entered');
            }
            if (utils.hasNoValue($scope.form.simplifyPrivateKey) || (newPaymentSetting && placeholderRegexp.test($scope.form.simplifyPrivateKey))) {
                errors.simplifyPrivateKey = gettextCatalog.getString('A private key must be entered');
            }

            return errors;
        };

        const savePaymentsCallback = function(promise) {
            const r = formHelper.handleResponse(promise);

            if (r.isSuccess()) {
                messageService.saveAlert();

                paymentgatewayService.loadPaymentSettingsList().then((data) => {
                    $rootScope.$broadcast('paymentSettingsChanged', data);
                });

                if ($scope.outletLevel) {
                    departmentService.clearDepartmentCache();
                    departmentService.loadDepartments().then((items) => {
                        $scope.departments = paymentgatewayService.getDepartments(paymentSetting, items);
                    });
                }

                // Reload the dashboard info
                $rootScope.$broadcast('reloadDashboard');

                // Reloading merchant info as the newly created payment setting
                // Will become the merchant's default payment setting
                if (!existingDefault)
                    $rootScope.$broadcast('outletInfoChanged');

                $uibModalInstance.close();
            } else {
                $scope.errors = {};
                // It need set error {} to show up the footer
                $scope.errors.error = '';
                $scope.saving = false;
                messageService.errorWithReason(promise.data.exception, '', true);
            }
        };

        const errorPaymentCallBack = function(error) {
                $scope.errors = {};
                // It need set error {} to show up the footer
                $scope.errors.error = '';
                $scope.saving = false;
                messageService.errorWithReason(error.data.exception, '', true);
        };

    $scope.changeDepartmentAssignment = function(department) {
        let index = -1;
        for (let i = 0; i < $scope.assignmentChanges.length; i++) {
            const item = $scope.assignmentChanges[i];
            if (item.id === department.id) {
                index = i;
                break;
            }
        }

        if (index > -1) {
            $scope.assignmentChanges.splice(index, 1);
        } else {
            $scope.assignmentChanges.push({id: department.id});
        }
    };

    $scope.isDefault = function() {
        return paymentSetting.fallback;
    };

    $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.ok = function() {
        if (validate($scope.paymentSystem.payment.name)) {
            savePaymentProvider($scope.paymentSystem.payment.name);
        }
    };

    init(paymentSetting);
}



// WEBPACK FOOTER //
// ./src/payment-gateway/controllers/payment.gateway.modal.controller.js